import React, { useContext } from "react";
import { Grid, TextField, ButtonBase } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import FacebookAdContext from "../../../../context/facebook_profiles/ad/AdContext";

// Components
import Image from "./Image";

const useStyles = makeStyles((theme) => ({
  paper: {
    width: "99%",
    border: "1px solid silver",
    borderRadius: 5,
    margin: "auto auto 0.8rem",
    paddingLeft: "0.5rem",
    paddingRight: "0.5rem",
  },
  removeBox: {
    textAlign: "right",
  },
  removeButton: {
    fontWeight: "bold",
    fontSize: "small",
    backgroundColor: "red",
    color: "white",
    width: "20px",
    height: "20px",
    padding: "4px",
    borderRadius: "3px",
    "&:focus": {
      outline: "none",
    },
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
    marginBottom: "17px",
  },
}));

const AdForm = ({ ad_id, ad_details, remove, handleDuplicate }) => {
  const classes = useStyles();

  const { list_cta, form_details, setFormDetails, form_errors, setFormErrors } =
    useContext(FacebookAdContext);

  const ad_errors = form_errors[ad_id];

  const handleChange = (e) => {
    const id = e.target.id;
    const value = e.target.value;

    switch (id) {
      case "name":
        if (value.length < 1) {
          ad_errors[id] = "Name cannot be empty!";
        } else if (value.length > 50) {
          ad_errors[id] = "Name cannot be more than 50 characters!";
        } else {
          ad_errors[id] = "";
        }
        break;

      case "page_id":
      case "CTA":
        if (value) ad_errors[id] = "";
        break;

      case "link":
        if (value.length < 1) {
          ad_errors[id] = "Link cannot be empty!";
        } else {
          ad_errors[id] = "";
        }
        break;

      default:
        break;
    }

    form_details[ad_id] = { ...ad_details, [id]: value };
    form_errors[ad_id] = ad_errors;
    setFormDetails(form_details);
    setFormErrors(form_errors);

    handleDuplicate();
  };

  return (
    <Grid item container spacing={1} className={classes.paper}>
      <Grid item container>
        <Grid item xs>
          <span
            style={{
              fontWeight: "bold",
              fontSize: 14,
            }}
          >
            {" "}
            {ad_details.name ? ad_details.name : "Ad"}{" "}
          </span>{" "}
        </Grid>
        <Grid item xs={1} className={classes.removeBox}>
          <ButtonBase
            name={ad_id}
            onClick={remove}
            focusRipple={true}
            className={classes.removeButton}
          >
            X{" "}
          </ButtonBase>{" "}
        </Grid>{" "}
      </Grid>
      <Grid item xs={4}>
        <TextField
          required
          fullWidth
          variant="outlined"
          size="small"
          margin="dense"
          label="Name"
          id="name"
          name="name"
          value={ad_details.name}
          onChange={handleChange}
          error={ad_errors.name ? true : false}
          helperText={ad_errors.name ? ad_errors.name : ""}
        />{" "}
      </Grid>
      <Grid item xs={4}>
        <TextField
          required
          fullWidth
          variant="outlined"
          select
          SelectProps={{
            native: true,
          }}
          size="small"
          margin="dense"
          label="Page ID"
          id="page_id"
          name="page_id"
          value={ad_details.page_id ? ad_details.page_id : "select"}
          onChange={handleChange}
          error={ad_errors.page_id ? true : false}
          helperText={ad_errors.page_id ? ad_errors.page_id : ""}
        >
          <option value="select" disabled>
            -- - select one-- -
          </option>{" "}
          <option value="Page 1"> Page 1 </option>{" "}
          <option value="Page 2"> Page 2 </option>{" "}
          {/* {list_page.map((each) => {
                        return (
                          <option key={each.id} value={each.id}>
                            {each.name} ({each.id})
                          </option>
                        );
                      })} */}{" "}
        </TextField>{" "}
      </Grid>
      <Grid item xs={4}>
        <TextField
          required
          fullWidth
          variant="outlined"
          select
          SelectProps={{
            native: true,
          }}
          size="small"
          margin="dense"
          label="CTA"
          id="CTA"
          name="CTA"
          value={ad_details.CTA ? ad_details.CTA : "select"}
          onChange={handleChange}
          error={ad_errors.CTA ? true : false}
          helperText={ad_errors.CTA ? ad_errors.CTA : ""}
        >
          <option value="select" disabled>
            -- - select one-- -
          </option>{" "}
          {list_cta.map((each, index) => {
            return (
              <option key={index} value={each}>
                {" "}
                {each}{" "}
              </option>
            );
          })}{" "}
        </TextField>{" "}
      </Grid>
      <Grid item xs={6}>
        <TextField
          required
          fullWidth
          variant="outlined"
          size="small"
          margin="dense"
          label="Link"
          id="link"
          name="link"
          value={ad_details.link}
          onChange={handleChange}
          error={ad_errors.link ? true : false}
          helperText={ad_errors.link ? ad_errors.link : ""}
        />{" "}
      </Grid>
      <Image ad_id={ad_id} ad_details={ad_details} ad_errors={ad_errors} />{" "}
    </Grid>
  );
};

export default AdForm;
